import { dividendsCalendarRoutes } from './routes';

export class DividendsCalendarEnvironment {
  public static getName = () => 'benzinga-calendar-dividends';

  public static getEnvironment = (env: Record<string, string>) => ({
    route: dividendsCalendarRoutes.dividends,
    token: env.token ?? '',
    url: new URL(env.url ?? 'https://api.benzinga.com/api/'),
  });
}
